
















































import store from '../../store'
import router from '../../router'
import { touchScreen } from '../../mixins/mixins'

export default {
  mixins: [touchScreen],
  data (this:any) {
    return {
      title: 'Livestock',
      isTouchScreen: this.detect(),
      enterprise: null,
      unsetPasture: false
    }
  },

  created: function (this:any) {
    // If the pasture is not set, call redirect dialog
    if (store.state.pasture === null) {
      this.unsetPasture = true
    // If the selected enterprise is sheep change route to livestock/sheep
    } else {
      this.enterprise = store.state.pasture.simulation.enterprise
      if (this.enterprise === 'Sheep') {
        router.push({
          name: 'Sheep',
          query: {
            ts: (new Date().getTime().toString()),
          }
        })
      } else {
        router.push({
          name: 'Cattle',
          query: {
            ts: (new Date().getTime().toString()),
          }
        })
      }
    }
  },

  store
}
